import { RequestService } from '../request/request.service';

import { IUserInfo } from './user-info.contract';

export class UserInfoService extends RequestService {
  public constructor(apiUrl: string) {
    super(apiUrl);
  }

  public getUserInfoById = async (userId: string) => {
    return this.fetcher<IUserInfo>(`/user-info/${userId}`);
  };

  public updateUserInfo = async (userId: string, userInfo: Partial<IUserInfo>) => {
    return this.putter<IUserInfo, Partial<IUserInfo>>(`/user-info/${userId}`, userInfo);
  };
}
